import axios from 'axios'
import {iamvar_serverUrl} from '../../../public/const.js'
export const amrest = axios.create({
  baseURL: iamvar_serverUrl + 'vzauth/'
})
export default amrest
